export default __webpack_public_path__ + "static/media/customer-success.ee62a128.png";